/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @type {string} Auditions action types.
 */

export const SET_LOADING = "[AUDITIONS] SET_LOADING";
export const SET_ALL_AUDITION_LIST = "[AUDITIONS] SET_ALL_AUDITION_LIST";
export const SET_ALL_AUDITION_LIST_META =
  "[AUDITIONS] SET_ALL_AUDITION_LIST_META";
export const SET_ACTIVE_AUDITION_LIST = "[AUDITIONS] SET_ACTIVE_AUDITION_LIST";
export const SET_ACTIVE_AUDITION_LIST_META =
  "[AUDITIONS] SET_ACTIVE_AUDITION_LIST_META";
export const SET_PAST_AUDITION_LIST = "[AUDITIONS] SET_PAST_AUDITION_LIST";
export const SET_PAST_AUDITION_LIST_META =
  "[AUDITIONS] SET_PAST_AUDITION_LIST_META";
export const SET_DRAFT_AUDITION_LIST = "[AUDITIONS] SET_DRAFT_AUDITION_LIST";
export const SET_DRAFT_AUDITION_LIST_META =
  "[AUDITIONS] SET_DRAFT_AUDITION_LIST_META";
export const SET_CLOSED_AUDITION_LIST = "[AUDITIONS] SET_CLOSED_AUDITION_LIST";
export const SET_CLOSED_AUDITION_LIST_META =
  "[AUDITIONS] SET_CLOSED_AUDITION_LIST_META";
export const SET_AUDITION = "[AUDITIONS] SET_AUDITION";
export const SET_AUDITION_TAB = "[AUDITIONS] SET_AUDITION_TAB";

export const SET_SELECTED_LOCATION = "[AUDITIONS] SET_SELECTED_LOCATION";
